module.exports = "<div class=modal-mask v-show=show v-transition=modal v-class=\"open: bodyModalOpen\"><div class=modal-wrapper><div class=modal-container v-style=\"max-width: width+'px' \"><div class=modal-header><strong>{{defaultTitle}}</strong> <button type=button class=close v-on=\"click: show = false\"><span aria-hidden=true>&times;</span></button></div><content select=.modal-body><div class=modal-body>default body</div></content><content select=.modal-footer><div class=modal-footer>default footer</div></content></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 77
// module chunks = 0